import React from 'react';
import { recentVisitedPageByUserUtil } from '../util-functions';
var useEffect = React.useEffect;
export var useHistoryEvent = function (user, history) {
    useEffect(function () {
        var unListen = history.listen(function () {
            if (user) {
                recentVisitedPageByUserUtil.addCurrentPage(user.name);
            }
        });
        return function () {
            unListen();
        };
    }, [history, user]);
};
